module.exports = __webpack_public_path__ + "img/various-icon-e.27cda3ba.png";